<template>
  <div class="footer">
    <div class="footer_box">
      <div class="msg">
        <div class="phone">
          <div class="num"> <img src="../assets/imgs/icon_phone.png" alt=""> <span>0755-33013550</span> </div>
          <div class="time">人工客服时间：工作日9:00-18:00</div>
        </div>
        <p class="address">公司地址：深圳市南山区深圳湾科技生态园7栋B座(西区)901室</p>
        <p class="copyright">
          Copyright ©2023 All Rights Reserved 深圳市怡信未来科技有限公司 /
          <a href="https://beian.miit.gov.cn">粤ICP备2023005580号</a>
        </p>
      </div>
      <div class="ewm_code">
        <p class="tit">扫码关注公众号</p>
        <img src="../assets/imgs/eaCode.jpg" alt="">
        <p class="tip">友情提示：市场有风险，借贷须谨慎</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
  .footer {
    margin-top: 50px;
    width: 100%;
    height: 200px;
    background: #ECF5FF;
  }

  .footer_box {
    margin: 0 auto;
    padding-top: 20px;
    width: 1200px;
    display: flex;
    justify-content: space-between;

    .num {
      display: flex;
      align-items: center;
      height: 40px;
      -webkit-text-shadow: 1px 1px 5px #999;
      -moz-text-shadow: 1px 1px 5px #999;
      text-shadow: 1px 1px 5px #999;
      letter-spacing: 2px;
      font-size: 26px;
      font-weight: 700;

      img {
        margin-right: 20px;
        width: 40px;
      }
    }

    .time {
      padding-left: 60px;
      line-height: 30px;
      font-size: 16px;
    }

    .address {
      padding-top: 20px;
      line-height: 30px;
      font-size: 18px;
    }

    .copyright {
      padding-top: 10px;
      line-height: 30px;
      font-size: 16px;
      color: #999;

      a {
        color: #666;
      }
    }
  }

  .ewm_code {
    line-height: 30px;
    text-align: center;
    font-size: 13px;

    .tit {
      color: #409EFF;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 100px;
      height: 100px;
      border: 1px solid #409EFF;
    }

    .tip {
      padding-top: 20px;
      color: #999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue